import '../../styles/style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useState, useEffect } from 'react';
import HeaderBar from './HeaderBar';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useData, usePunishments } from './MemberData';
import Swal from 'sweetalert2';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { useTheme } from './ThemeContext';
import { Checkbox, CheckboxProps, styled } from "@mui/material";

import { ToastContainer, toast } from "react-toastify";
import Cookies from 'js-cookie';
import axios from 'axios';

let myDiscordID = ''

interface Member {
  user_id: number;
  full_name: string;
  callsign: number;
  rank: string;
  entry_date: string | Date;
  last_up: string | Date;
  discordID: string;
  functions?: Record<string, boolean | string>;
  certificates?: Record<string, boolean | string>;
  fw: number;
  notes: string;
  grade: string;
  reintegrated: boolean;
}

function MembersPage() {
  const { membersPunishments } = usePunishments();
  const { theme } = useTheme();
  const { membersData, loading, getMemberInfo, getDiscordMemberInfo, fetchData, refreshAccessToken } = useData();
  const [searchTerm, setSearchTerm] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedMemberData, setSelectedMemberData] = useState<Member | undefined>(undefined);
  const [isEditing, setIsEditing] = useState(false);
  const [isHR, setIsHR] = useState(false);
  const [isConducere, setIsConducere] = useState(false);
  const [upCallsign, setUPCallsign] = useState("");
  const [upModalOpen, setUpModalOpen] = useState(false);
  const [downCallsign, setDOWNCallsign] = useState("")
  const [downModalOpen, setDownModalOpen] = useState(false);
  const [oldCallsignModal, setOldCallsign] = useState("");
  const [newCallsignModal, setNewCallsign] = useState("");
  const [changeCallsignOpen, setOpenChangeCallsignModal] = useState(false);
  const [modalFWInput, setFWInput] = useState("");
  const [fwModalOpen, setFWModalOpen] = useState(false);
  const [fineModalOpen, setFineModalOpen] = useState(false);
  const [fineReason, setFineReason] = useState("");
  const [fineAmount, setFineAmount] = useState("");
  const [OpenDemiteModal, setDemitereModalOpen] = useState(false);
  const [demiteCallsign, setDemiteCallsign] = useState("");
  const [demiteDays, setDemiteDays] = useState("");
  const [cooldownsModalOpen, setCooldownsModalOpen] = useState(false);
  const [promoted, setPromoted] = useState(false);
  const [suspended, setSuspended] = useState(false);
  const [cooldownTest, setCooldownTest] = useState("");
  const [cooldownDays, setCooldownDays] = useState("");
  const [checkCooldownsModalOpen, setCheckCooldownsModalOpen] = useState(false);
  const [checkCooldownsCallsign, setCheckCooldownsCallsign] = useState("");
  const [checkedCooldowns, setCheckedCooldowns] = useState([]);
  const [doubleUpModalOpen, setDoubleUpModalOpen] = useState(false);

  useEffect(() => {
    let isHRTemp = false;
    let isConducereTemp = false;
    myDiscordID = Cookies.get('myDiscordID') || '';

    for (let index = 0; index < membersData.length; index++) {
      const member = membersData[index];
      if (member.discordID === myDiscordID && (member.grade === "Director-General" || member.grade === "Director-Adjunct" || member.grade === "Medic-Inspector" || member.grade === "Medic-Chirurg")) {
        isConducereTemp = true;
      }
      if (member.discordID === myDiscordID) {
        if (member.functions?.['instructor panel'] === true || typeof member.functions?.['instructor panel'] === "string") {
          isHRTemp = true;
        }
      }
    }
    
    setIsHR(isHRTemp);
    setIsConducere(isConducereTemp);
  }, [membersData]);

  const handleOpen = (mDiscordID: string) => {
    const memberData = membersData.find((member) => member.discordID === mDiscordID);
    if (memberData) {
      setSelectedMemberData(memberData);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setIsEditing(false);
    setOpen(false)
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '65%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: theme === 'dark' ? 'black' : 'white',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 4,
  };

  const upDownStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '25%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: theme === 'dark' ? '#191919' : 'white',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const demisieStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '30%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: theme === 'dark' ? '#191919' : 'white',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const cooldownsStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '40%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: theme === 'dark' ? '#191919' : 'white',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const changeCallsignStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '32%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: theme === 'dark' ? '#191919' : 'white',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  function validateString(input: string | null) {
    if (!input) return false;

    if (/[^0-9]/.test(input)) return false;

    if (input.startsWith('-')) return false;

    if (input.length > 3) return false;

    return true;
  }

  if (loading) {
      return (
        <div className="w-full h-full flex flex-col">
          <HeaderBar currentPage="Membrii Departament"/>
          <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
            <div className="w-full h-full flex items-center justify-between">
              <span className="w-full textExtraBold text-[#323232] text-[2vw] flex items-center justify-center">Pagina se incarca!</span>
            </div>
          </div>
        </div>
      );
  }

  const filteredMembers = membersData
  .filter((member) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      member.full_name.toLowerCase().includes(searchLower) ||
      String(member.callsign).padStart(3, '0').includes(searchLower) ||
      String(member.user_id).includes(searchLower)
    );
  })
  .sort((a, b) => a.callsign - b.callsign); 

  const toggleEditMode = async () => {
    if (isEditing === true && open === true) {
      try {
        let token = Cookies.get("accessToken");
  
        await axios.post('http://panelmedici.fplayt.ro:5000/api/update-member', {
          memberData: selectedMemberData
        }, { headers: { Authorization: `Bearer ${token}` } });
        
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
  
        if (selectedMemberData) {
          await axios.post('http://panelmedici.fplayt.ro:5000/createHRLogs', {
            type: "UPDATE ATRIBUTII", 
            memberName: `[M-${String(selectedMemberData?.callsign).padStart(3, '0')}] ${getMemberInfo(selectedMemberData?.callsign, "full_name")}`, 
            date_time: `${day}.${month}.${year} - ${hours}:${minutes}`,
            pType: "",
            fromCS: "",
            cType: ""
          }, { headers: { Authorization: `Bearer ${token}` } });
        }
  
        toast.success("Ai salvat modificarile!");
      } catch (error) {
        if ((error as any).response && (error as any).response.status === 401) {
          const newAccessToken = await refreshAccessToken();
  
          if (newAccessToken) {
            try {
              await axios.post('http://panelmedici.fplayt.ro:5000/api/update-member', {
                memberData: selectedMemberData
              }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
              
              const now = new Date();
              const day = String(now.getDate()).padStart(2, '0');
              const month = String(now.getMonth() + 1).padStart(2, '0');
              const year = now.getFullYear();
              const hours = String(now.getHours()).padStart(2, '0');
              const minutes = String(now.getMinutes()).padStart(2, '0');
  
              if (selectedMemberData) {
                await axios.post('http://panelmedici.fplayt.ro:5000/createHRLogs', {
                  type: "UPDATE ATRIBUTII", 
                  memberName: `[M-${String(selectedMemberData?.callsign).padStart(3, '0')}] ${getMemberInfo(selectedMemberData?.callsign, "full_name")}`, 
                  date_time: `${day}.${month}.${year} - ${hours}:${minutes}`,
                  pType: "",
                  fromCS: "",
                  cType: ""
                }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
              }
  
              toast.success("Ai salvat modificarile!");
            } catch (retryError) {
              toast.error("A aparut o eroare! Modificarile nu au fost salvate.");
              console.error('Error retrying with new token:', retryError);
            }
          } else {
            toast.error("Nu s-a putut actualiza token-ul de acces.");
          }
        } else {
          toast.error("A aparut o eroare! Modificarile nu au fost salvate.");
          console.error('Error updating member:', error);
        }
      }
    }
    setIsEditing(!isEditing);
  };
  
  const handleToggleFunction = (key: string, newValue: boolean | string) => {
    if (!selectedMemberData) return;
  
    const functions =
      typeof selectedMemberData.functions === "string"
        ? JSON.parse(selectedMemberData.functions)
        : selectedMemberData.functions;
  
    const updatedFunctions = {
      ...functions,
      [key]: newValue,
    };
  
    setSelectedMemberData({
      ...selectedMemberData,
      functions: updatedFunctions,
    });
  };

  const handleToggleCertificate = (key: string, newValue: boolean | string) => {
    if (!selectedMemberData) return;
  
    const certificates =
      typeof selectedMemberData.certificates === "string"
        ? JSON.parse(selectedMemberData.certificates)
        : selectedMemberData.certificates;
  
    const updatedCertificates = {
      ...certificates,
      [key]: newValue,
    };
  
    setSelectedMemberData({
      ...selectedMemberData,
      certificates: updatedCertificates,
    });
  };

  const handleOpenFWModal = () => {
    setFWModalOpen(true);
  }

  const handleFWClose = () => {
    setFWInput("");
    setFWModalOpen(false);
  }

  async function giveFW() {
    let userInput = modalFWInput;
    const fwCount = getMemberInfo(Number(selectedMemberData?.callsign), "fw") || 0;
    let webhookSend = false;
  
    if (fwCount === 2) {
      handleClose();
      handleFWClose();
      const result = await Swal.fire({
        title: `Ești sigur ca vrei sa ii oferi un FW lui [M-${selectedMemberData?.callsign?.toString().padStart(3, '0')}]?`,
        text: "Acesta are 2 FW-uri si va fi DEMIS automat la al 3-lea!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Da, continuă",
        cancelButtonText: "Anulează",
        confirmButtonColor: "#D8630F",
      });
  
      if (!result.isConfirmed) {
        toast.info("Ai anulat acțiunea de FW!");
        return;
      } else {
        webhookSend = true;
      }
    }
  
    if (userInput !== null) {
      try {
        let token = Cookies.get("accessToken");
        try {
          const date = new Date();
          const formatter = new Intl.DateTimeFormat('ro-RO');
          const formattedDate = formatter.format(date).replace(/\//g, '.');
          date.setDate(date.getDate() + 7);
          const formatter2 = new Intl.DateTimeFormat('ro-RO');
          const formattedDate2 = formatter2.format(date).replace(/\//g, '.');
  
          await axios.post("http://panelmedici.fplayt.ro:5000/api/give-fw", {
            pType: "FW",
            reason: userInput,
            fullName: getMemberInfo(Number(selectedMemberData?.callsign), "full_name"),
            amount: 75000,
            hr: `[M-${getDiscordMemberInfo(myDiscordID, "callsign").toString().padStart(3, '0')}]`, 
            date: formattedDate, 
            expire: formattedDate2,
            callsign: selectedMemberData?.callsign?.toString().padStart(3, '0'),
            type: 'fw',
            email: getMemberInfo(Number(selectedMemberData?.callsign), "email"),
            discordID: getMemberInfo(Number(selectedMemberData?.callsign), "discordID"),
            hrDiscordID: myDiscordID
          }, { headers: { Authorization: `Bearer ${token}` } });
        } catch (error) {
          if ((error as any).response && (error as any).response.status === 401) {
  
            const newAccessToken = await refreshAccessToken();
  
            if (newAccessToken) {
              const date = new Date();
              const formatter = new Intl.DateTimeFormat('ro-RO');
              const formattedDate = formatter.format(date).replace(/\//g, '.');
              date.setDate(date.getDate() + 7);
              const formatter2 = new Intl.DateTimeFormat('ro-RO');
              const formattedDate2 = formatter2.format(date).replace(/\//g, '.');
  
              await axios.post("http://panelmedici.fplayt.ro:5000/api/give-fw", {
                pType: "FW",
                reason: userInput,
                fullName: getMemberInfo(Number(selectedMemberData?.callsign), "full_name"),
                amount: 75000,
                hr: `[M-${getDiscordMemberInfo(myDiscordID, "callsign").toString().padStart(3, '0')}]`, 
                date: formattedDate, 
                expire: formattedDate2,
                callsign: selectedMemberData?.callsign?.toString().padStart(3, '0'),
                type: 'fw',
                email: getMemberInfo(Number(selectedMemberData?.callsign), "email"),
                discordID: getMemberInfo(Number(selectedMemberData?.callsign), "discordID"),
                hrDiscordID: myDiscordID
              }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
            }
          } else {
            throw error;
          }
        }
  
        handleFWClose();
        toast.success(`Ai acordat un FW lui [M-${selectedMemberData?.callsign?.toString().padStart(3, '0')}] cu motivul: ${userInput}`);
  
        if (webhookSend) {
          let banDays = "0";
          let contentMessage = parseInt(banDays) > 0 ? `<@&856206889577742347> Ban ${banDays}d (**Esuarea de a sta intr-o factiune legala**)` : '';
          if (parseInt(banDays) === 30) {
            contentMessage = `<@&856206889577742347> Ban ${banDays}d (**CORUPTIE**)`;
          }
          const payload = {
            content: contentMessage,
            embeds: [
              {
                title: "CERERE GRAD MEDICI",
                fields: [
                  { name: 'HR', value: `**<@${myDiscordID}>**`, inline: false },
                  { name: 'Tip', value: `**SCOATERE**`, inline: false },
                  { name: 'Grad', value: `**${selectedMemberData?.grade}**`, inline: false },
                  { name: 'ID', value: `**${selectedMemberData?.user_id}**`, inline: false },
                ],
                color: 0xf53c2f,
              },
            ],
          };
          if (selectedMemberData) {
            axios.post("http://panelmedici.fplayt.ro:5000/fw/cumulated", {
              payload: payload,
              discordID: getMemberInfo(selectedMemberData?.callsign, "discordID"),
              hrDiscordID: myDiscordID,
              grade: selectedMemberData?.grade,
              user_id: selectedMemberData?.user_id
            }, { headers: { Authorization: `Bearer ${token}` } })
          }
        }
      } catch (error) {
        console.log(error);
        toast.error("A apărut o eroare! FW-ul nu a fost acordat.");
      }
    } else {
      toast.info("Ai anulat acțiunea de FW!");
    }
  }
  
  

  function validateMoneyString(input: string | null) {
    if (!input) return false;

    if (/[^0-9]/.test(input)) return false;

    if (input.startsWith('-')) return false;


    return true;
  }

  const handleFineClose = () => {
    setFineReason("");
    setFineAmount("");
    setFineModalOpen(false);
  }

  const handleOpenFineModal = () => {
    setFineModalOpen(true);
  }

  async function giveFine() {
    let userInput = fineReason;
    let amountInput = fineAmount;
    if (userInput !== null) {
      try {
        if (validateMoneyString(amountInput) === false) {
          toast.error("Valoarea amenzii este invalida!");
          return;
        }
        if (!amountInput) {
          toast.error("Valoare invalida!");
          return;
        } else {
          const currentDate = new Date();
          const formatter = new Intl.DateTimeFormat('ro-RO');
          const formattedDate = formatter.format(currentDate).replace(/\//g, '.');

          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 7);
          const formattedDate2 = formatter.format(expirationDate).replace(/\//g, '.');

          const callsign = selectedMemberData?.callsign?.toString().padStart(3, '0');
          if (!callsign) {
              toast.error("Callsign-ul nu este valid.");
              return;
          }

          const memberName = getMemberInfo(Number(selectedMemberData?.callsign), "full_name");
          if (!memberName) {
              toast.error("Numele membrului nu a fost găsit.");
              return;
          }

          let token = Cookies.get("accessToken");

          try {
              if (selectedMemberData) {
                  await axios.post('http://panelmedici.fplayt.ro:5000/api/give-fw', {
                      pType: "AMENDA",
                      reason: userInput,
                      fullName: getMemberInfo(selectedMemberData.callsign, "full_name"),
                      amount: amountInput,
                      hr: `[M-${getDiscordMemberInfo(myDiscordID, "callsign").toString().padStart(3, '0')}]`,
                      date: formattedDate,
                      expire: formattedDate2,
                      callsign: callsign,
                      type: 'fine',
                      email: getMemberInfo(selectedMemberData.callsign, "email"),
                      discordID: getMemberInfo(Number(selectedMemberData?.callsign), "discordID"),
                      hrDiscordID: myDiscordID
                  }, { headers: { Authorization: `Bearer ${token}` } });
              }

              handleFineClose();
              toast.success(`Ai acordat o AMENDA lui [M-${callsign}] cu motivul: ${userInput}`);
          } catch (error) {
            if ((error as any).response && (error as any).response.status === 401) {

              const newAccessToken = await refreshAccessToken();

              if (newAccessToken) {
                if (selectedMemberData) {
                    await axios.post('http://panelmedici.fplayt.ro:5000/api/give-fw', {
                      pType: "AMENDA",
                      reason: userInput,
                      fullName: getMemberInfo(selectedMemberData.callsign, "full_name"),
                      amount: amountInput,
                      hr: `[M-${getDiscordMemberInfo(myDiscordID, "callsign").toString().padStart(3, '0')}]`,
                      date: formattedDate,
                      expire: formattedDate2,
                      callsign: callsign,
                      type: 'fine',
                      email: getMemberInfo(selectedMemberData.callsign, "email"),
                      discordID: getMemberInfo(Number(selectedMemberData?.callsign), "discordID"),
                      hrDiscordID: myDiscordID
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
                }

                handleFineClose();
                toast.success(`Ai acordat o AMENDA lui [M-${callsign}] cu motivul: ${userInput}`);
              }
            } else {
                console.error('Error:', error);
                toast.error("A apărut o eroare! Amenda-ul nu a fost acordata.");
            }
          }
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error("A apărut o eroare! Amenda-ul nu a fost acordata.");
      }
    } else {
        toast.info("Ai anulat acțiunea de Amenda!");
    }
  }


  const openChangeCallsignModal = async () => {
    setOpenChangeCallsignModal(true);
  }

  const changeCallsign = async () => {
    let oldCallsign = oldCallsignModal;
    let newCallsign = newCallsignModal;
    if (oldCallsign !== null) {
        if (validateString(newCallsign) === false) {
            toast.error("Callsign nou invalid!");
            return;
        }
        if (newCallsign !== null) {
            let findMember = membersData.find((m) => m.callsign === Number(oldCallsign));
            if (findMember) {
                let checkCallsign = membersData.find((m) => m.callsign === Number(newCallsign));
                if (checkCallsign) {
                    toast.error("Exista un membru care are noul callsign deja!");
                    return;
                } else {
                    let token = Cookies.get("accessToken");

                    try {
                        const response = await axios.post("http://panelmedici.fplayt.ro:5000/member/changeCallsign", {
                            oldCallsign: findMember.callsign,
                            newCallsign: Number(newCallsign),
                            discordID: getMemberInfo(findMember.callsign, "discordID")
                        }, { headers: { Authorization: `Bearer ${token}` } });

                        if (response.statusText === "OK") {
                            fetchData();
                            setOldCallsign("");
                            setNewCallsign("");
                            setOpenChangeCallsignModal(false);
                            toast.success("Callsign modificat cu succes!");
                        } else {
                            toast.error("A aparut o eroare! Callsign-ul nu a fost modificat.");
                        }
                    } catch (error) {
                        if ((error as any).response && (error as any).response.status === 401) {

                            const newAccessToken = await refreshAccessToken();

                            if (newAccessToken) {
                                const response = await axios.post("http://panelmedici.fplayt.ro:5000/member/changeCallsign", {
                                    oldCallsign: findMember.callsign,
                                    newCallsign: Number(newCallsign),
                                    discordID: getMemberInfo(findMember.callsign, "discordID")
                                }, { headers: { Authorization: `Bearer ${newAccessToken}` } });

                                if (response.statusText === "OK") {
                                    fetchData();
                                    setOldCallsign("");
                                    setNewCallsign("");
                                    setOpenChangeCallsignModal(false);
                                    toast.success("Callsign modificat cu succes!");
                                } else {
                                    toast.error("A aparut o eroare! Callsign-ul nu a fost modificat.");
                                }
                            }
                        } else {
                            console.error("Error changing callsign:", error);
                            toast.error("A aparut o eroare! Callsign-ul nu a fost modificat.");
                        }
                    }
                }
            } else {
                toast.error("Nu exista niciun medic cu acest callsign!");
                return;
            }
        } else {
            toast.error("Callsign invalid!");
            return;
        }
    } else {
        toast.error("Callsign invalid!");
        return;
    }
  }

  const checkPunishments = (sCallsign: number) => {
    let totalFW = 0;
    let fwActive = 0;
    let totalFines = 0;
    let finesActive = 0;
    for (let index = 0; index < membersPunishments.length; index++) {
      const element = membersPunishments[index];
      const punishmentsTable = JSON.parse(element.punishments);
      if (Number(element.callsign) === sCallsign) {
        if (punishmentsTable.pType === "AMENDA") {
          totalFines++;
        } else {
          totalFW++;
        }
        if (punishmentsTable.pType === "AMENDA" && punishmentsTable.status === false) {
          finesActive++;
        }
        if (punishmentsTable.pType === "FW" && punishmentsTable.status === false) {
          fwActive++;
        }
      }
    }
    toast.info(`Amenzi totale: ${totalFines}\n Amenzi active: ${finesActive}\n FW-uri totale: ${totalFW}\n FW-uri active: ${fwActive}`)
  }

  const getNextCallsign = (db: any, callsignType: number) => {
    const existingCallsigns = db.map((item: { callsign: any; }) => item.callsign).sort((a: number, b: number) => a - b);

    const unavailableBases = [500, 400, 300, 200, 100];

    if (unavailableBases.includes(callsignType)) {
        callsignType++;
    }

    let nextCallsign = callsignType;

    while (existingCallsigns.includes(nextCallsign) || unavailableBases.includes(nextCallsign)) {
        nextCallsign++;
    }

    return nextCallsign;
  };

  const getCurrentDateInRomania = (): string => {
    const romaniaTime = new Date().toLocaleString("en-US", {
      timeZone: "Europe/Bucharest",
    });
    const date = new Date(romaniaTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const openUpMemberModal = async () => {
    setUpModalOpen(true);
  }

  const openDoubleUpMemberModal = async () => {
    setDoubleUpModalOpen(true);
  }

  const upMember = async () => {
    let newCallsign;
    let grade;
    if (upCallsign) {
        let user_id = getMemberInfo(Number(upCallsign), "user_id");

        if (Number(upCallsign) > 500) {
            newCallsign = getNextCallsign(membersData, 400);
            grade = "Medic-Stagiar";
        } else if (Number(upCallsign) > 400) {
            newCallsign = getNextCallsign(membersData, 300);
            grade = "Medic-Rezident";
        } else if (Number(upCallsign) > 300) {
            newCallsign = getNextCallsign(membersData, 200);
            grade = "Medic-Specialist";
        } else if (Number(upCallsign) > 200) {
            newCallsign = getNextCallsign(membersData, 100);
            grade = "Medic-Primar";
        } else if (Number(upCallsign) > 100 && Number(upCallsign) < 200) {
            newCallsign = getNextCallsign(membersData, 7);
            grade = "Medic-Chirurg";
        } else if (Number(upCallsign) > 6 && Number(upCallsign) < 100) {
            newCallsign = getNextCallsign(membersData, 4);
            grade = "Medic-Inspector";
        } else if (Number(upCallsign) > 3 && Number(upCallsign) < 20) {
            newCallsign = getNextCallsign(membersData, 2);
            grade = "Director-Adjunct";
        } else if (Number(upCallsign) === 2 || Number(upCallsign) === 3) {
            newCallsign = getNextCallsign(membersData, 1);
            grade = "Director-General";
        }

        let token = Cookies.get("accessToken");
        try {
            const response = await axios.post('http://panelmedici.fplayt.ro:5000/member/updown', {
                newCallsign: newCallsign,
                grade: grade,
                last_up: getCurrentDateInRomania(),
                oldCallsign: Number(upCallsign),
                discordID: getMemberInfo(Number(upCallsign), "discordID"),
                hrDiscordID: myDiscordID,
                user_id: user_id,
                type: "up"
            }, { headers: { Authorization: `Bearer ${token}` } });

            if (response.statusText !== "OK") {
                toast.error("A aparut o eroare! UP-ul nu a fost acordat");
            } else {
                fetchData();
                setUpModalOpen(false);
                toast.success("Up-ul a fost acordat cu succes!");
            }
        } catch (error) {
            if ((error as any).response && (error as any).response.status === 401) {

                const newAccessToken = await refreshAccessToken();

                if (newAccessToken) {
                    const response = await axios.post('http://panelmedici.fplayt.ro:5000/member/updown', {
                        newCallsign: newCallsign,
                        grade: grade,
                        last_up: getCurrentDateInRomania(),
                        oldCallsign: Number(upCallsign),
                        discordID: getMemberInfo(Number(upCallsign), "discordID"),
                        hrDiscordID: myDiscordID,
                        user_id: user_id,
                        type: "up"
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });

                    if (response.statusText !== "OK") {
                        toast.error("A aparut o eroare! UP-ul nu a fost acordat");
                    } else {
                        fetchData();
                        setUpModalOpen(false);
                        toast.success("Up-ul a fost acordat cu succes!");
                    }
                }
            } else {
                console.error("Error in upMember:", error);
                toast.error("A aparut o eroare! UP-ul nu a fost acordat");
            }
        }
    } else {
        toast.error("Ai anulat actiunea de UP!");
    }
}

  const doubleUpMember = async () => {
    let newCallsign;
    let grade;
    if (upCallsign) {
      let user_id = getMemberInfo(Number(upCallsign), "user_id");
      newCallsign = getNextCallsign(membersData, 300);
      grade = "Medic-Rezident";

      let token = Cookies.get("accessToken");
      try {
        const response = await axios.post('http://panelmedici.fplayt.ro:5000/member/updown', {
            newCallsign: newCallsign,
            grade: grade,
            last_up: getCurrentDateInRomania(),
            oldCallsign: Number(upCallsign),
            discordID: getMemberInfo(Number(upCallsign), "discordID"),
            hrDiscordID: myDiscordID,
            user_id: user_id,
            type: "up"
        }, { headers: { Authorization: `Bearer ${token}` } });

        if (response.statusText !== "OK") {
            toast.error("A aparut o eroare! DOUBLE UP-ul nu a fost acordat");
        } else {
            fetchData();
            setUpModalOpen(false);
            toast.success("Up-ul a fost acordat cu succes!");
        }
      } catch (error) {
        if ((error as any).response && (error as any).response.status === 401) {

          const newAccessToken = await refreshAccessToken();

          if (newAccessToken) {
            const response = await axios.post('http://panelmedici.fplayt.ro:5000/member/updown', {
              newCallsign: newCallsign,
              grade: grade,
              last_up: getCurrentDateInRomania(),
              oldCallsign: Number(upCallsign),
              discordID: getMemberInfo(Number(upCallsign), "discordID"),
              hrDiscordID: myDiscordID,
              user_id: user_id,
              type: "up"
            }, { headers: { Authorization: `Bearer ${newAccessToken}` } });

            if (response.statusText !== "OK") {
              toast.error("A aparut o eroare! DOUBLE UP-ul nu a fost acordat");
            } else {
              fetchData();
              setUpModalOpen(false);
              toast.success("Up-ul a fost acordat cu succes!");
            }
          }
        } else {
          console.error("Error in doubleUpMember:", error);
          toast.error("A aparut o eroare! DOUBLE UP-ul nu a fost acordat");
        }
      }
    } else {
      toast.error("Ai anulat actiunea de UP!");
    }
  }

  const formatDate = (date: string | Date): string => {
    if (date === null) {
      return 'N/A';
    }
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const openDownMemberModal = async () => {
    setDownModalOpen(true);
  }

  const downMember = async () => {
    let newCallsign;
    let grade;
    if (downCallsign) {
        let user_id = getMemberInfo(Number(downCallsign), "user_id");

        if (Number(downCallsign) > 400) {
            newCallsign = getNextCallsign(membersData, 500);
            grade = "Asistent-Medical";
        } else if (Number(downCallsign) > 300) {
            newCallsign = getNextCallsign(membersData, 400);
            grade = "Medic-Stagiar";
        } else if (Number(downCallsign) > 200) {
            newCallsign = getNextCallsign(membersData, 300);
            grade = "Medic-Rezident";
        } else if (Number(downCallsign) > 100) {
            newCallsign = getNextCallsign(membersData, 200);
            grade = "Medic-Specialist";
        } else if (Number(downCallsign) > 6 && Number(downCallsign) < 20) {
            newCallsign = getNextCallsign(membersData, 100);
            grade = "Medic-Primar";
        } else if (Number(downCallsign) > 3 && Number(downCallsign) < 7) {
            newCallsign = getNextCallsign(membersData, 7);
            grade = "Medic-Chirurg";
        } else if (Number(downCallsign) > 1 && Number(downCallsign) < 4) {
            newCallsign = getNextCallsign(membersData, 4);
            grade = "Medic-Inspector";
        } else if (Number(downCallsign) === 1) {
            newCallsign = getNextCallsign(membersData, 2);
            grade = "Director-Adjunct";
        }

        let token = Cookies.get("accessToken");
        try {
            const response2 = await axios.post('http://panelmedici.fplayt.ro:5000/member/updown', {
                newCallsign: newCallsign,
                grade: grade,
                last_up: getCurrentDateInRomania(),
                oldCallsign: Number(downCallsign),
                discordID: getMemberInfo(Number(downCallsign), "discordID"),
                hrDiscordID: myDiscordID,
                user_id: user_id,
                type: "down"
            }, { headers: { Authorization: `Bearer ${token}` } });

            if (response2.statusText !== "OK") {
                toast.error("A aparut o eroare! DOWN-ul nu a fost acordat");
            } else {
                fetchData();
                setDownModalOpen(false);
                toast.success("DOWN-ul a fost acordat cu succes!");
            }
        } catch (error) {
            if ((error as any).response && (error as any).response.status === 401) {

                const newAccessToken = await refreshAccessToken();

                if (newAccessToken) {
                    const response2 = await axios.post('http://panelmedici.fplayt.ro:5000/member/updown', {
                        newCallsign: newCallsign,
                        grade: grade,
                        last_up: getCurrentDateInRomania(),
                        oldCallsign: Number(downCallsign),
                        discordID: getMemberInfo(Number(downCallsign), "discordID"),
                        hrDiscordID: myDiscordID,
                        user_id: user_id,
                        type: "down"
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });

                    if (response2.statusText !== "OK") {
                        toast.error("A aparut o eroare! DOWN-ul nu a fost acordat");
                    } else {
                        fetchData();
                        setDownModalOpen(false);
                        toast.success("DOWN-ul a fost acordat cu succes!");
                    }
                }
            } else {
                console.error("Error in downMember:", error);
                toast.error("A aparut o eroare! DOWN-ul nu a fost acordat");
            }
        }
    } else {
        toast.error("Ai anulat actiunea de DOWN!");
    }
  }

  
  const handleDemitereClose = () => {
    setDemiteCallsign("");
    setDemitereModalOpen(false);
  }

  const handleOpenOutMember = () => {
    setDemitereModalOpen(true);
  }

  const outMember = async () => {
    handleDemitereClose();
    let content2;
    if (Number(demiteDays) < 30) {
        content2 = `+ <@&856206889577742347> Ban ${demiteDays}d (**Esuarea de a sta intr-o factiune legala**)`;
    } else if (Number(demiteDays) === 30) {
        content2 = `+ <@&856206889577742347> Ban ${demiteDays}d (**Coruptie**)`;
    }
    if (Number(demiteDays) === 0) {
        content2 = null;
    }
    
    const payload = {
        content: content2,
        embeds: [
            {
                title: "CERERE GRAD MEDICI",
                fields: [
                    { name: 'HR', value: `<@${myDiscordID}>`, inline: false },
                    { name: 'Tip', value: `**SCOATERE**`, inline: false },
                    { name: 'Grad', value: `**${getMemberInfo(Number(demiteCallsign), 'grade')}**`, inline: false },
                    { name: 'ID', value: `**${getMemberInfo(Number(demiteCallsign), 'user_id')}**`, inline: false },
                ],
                color: 0xf53c2f,
            },
        ],
    };

    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    try {
        let token = Cookies.get("accessToken");
        const response = await axios.post("http://panelmedici.fplayt.ro:5000/deleteMemberData", {
            callsign: Number(demiteCallsign),
            email: getMemberInfo(Number(demiteCallsign), "email"),
            discordID: getMemberInfo(Number(demiteCallsign), "discordID"),
            hrDiscordID: myDiscordID,
            full_name: getMemberInfo(Number(demiteCallsign), "full_name"),
            payload: payload,
        }, { headers: { Authorization: `Bearer ${token}` } });

        if (response.statusText !== "OK") {
            toast.error("A aparut o eroare! Membrul nu a fost sters din baza de date!");
            return;
        }

        try {
            const response2 = await axios.post("http://panelmedici.fplayt.ro:5000/createHRLogs", {
                type: "DEMITERE",
                memberName: `[M-${String(Number(demiteCallsign)).padStart(3, '0')}] ${getMemberInfo(Number(demiteCallsign), "full_name")}`,
                date_time: `${day}.${month}.${year} - ${hours}:${minutes}`,
                pType: "",
                fromCS: "",
                cType: "",
            }, { headers: { Authorization: `Bearer ${token}` } });

            if (response2.statusText === "OK") {
                fetchData();
                toast.success("DEMITERE efectuata cu succes!");
            } else {
                toast.error("A aparut o eroare! Demiterea nu a fost trecuta in Istoric HR!");
            }

        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Demiterea nu a fost trecuta in Istoric HR!");
        }

    } catch (error) {
        if ((error as any).response && (error as any).response.status === 401) {
            const newAccessToken = await refreshAccessToken();

            if (newAccessToken) {
                try {
                    const response = await axios.post("http://panelmedici.fplayt.ro:5000/deleteMemberData", {
                        callsign: Number(demiteCallsign),
                        email: getMemberInfo(Number(demiteCallsign), "email"),
                        discordID: getMemberInfo(Number(demiteCallsign), "discordID"),
                        hrDiscordID: myDiscordID,
                        full_name: getMemberInfo(Number(demiteCallsign), "full_name"),
                        payload: payload,
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });

                    if (response.statusText !== "OK") {
                        toast.error("A aparut o eroare! Membrul nu a fost sters din baza de date!");
                        return;
                    }

                    const response2 = await axios.post("http://panelmedici.fplayt.ro:5000/createHRLogs", {
                        type: "DEMITERE",
                        memberName: `[M-${String(Number(demiteCallsign)).padStart(3, '0')}] ${getMemberInfo(Number(demiteCallsign), "full_name")}`,
                        date_time: `${day}.${month}.${year} - ${hours}:${minutes}`,
                        pType: "",
                        fromCS: "",
                        cType: "",
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });

                    if (response2.statusText === "OK") {
                        fetchData();
                        toast.success("DEMITERE efectuata cu succes!");
                    } else {
                        toast.error("A aparut o eroare! Demiterea nu a fost trecuta in Istoric HR!");
                    }

                } catch (error) {
                    toast.error("A aparut o eroare! Demiterea nu a fost trecuta in Istoric HR!");
                    console.log(error);
                }
            }
        } else {
            console.error('Error sending webhook:', error);
            toast.error("A aparut o eroare! Demiterea nu a fost procesata!");
        }
    }
}


  const handleUpModalClose = () => {
    setUPCallsign('');
    setUpModalOpen(false);
    setDoubleUpModalOpen(false);
  }

  const handleDownModalClose = () => {
    setDOWNCallsign('');
    setDownModalOpen(false);
  }

  const handleChangeCallsignModalClose = () => {
    setOldCallsign("");
    setNewCallsign("");
    setOpenChangeCallsignModal(false);
  }

  const handleOpenCooldownsModal = () => {
    setOpen(false);
    setCooldownsModalOpen(true);
  }

  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 23,
    height: 23,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
        ...theme.applyStyles('dark', {
        backgroundColor: '#30404d',
        }),
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
        ...theme.applyStyles('dark', {
        background: 'rgba(57,75,89,.5)',
        }),
    },
    ...theme.applyStyles('dark', {
        boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
        backgroundColor: '#394b59',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
    }),
}));
  
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#0077ff',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'block',
        width: 23,
        height: 23,
        backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#0077ff',
    },
});
  
  function BpCheckbox(props: JSX.IntrinsicAttributes & CheckboxProps) {
      return (
          <Checkbox
              sx={{ '&:hover': { bgcolor: 'transparent' } }}
              disableRipple
              color="default"
              checkedIcon={<BpCheckedIcon />}
              icon={<BpIcon />}
              inputProps={{ 'aria-label': 'Checkbox demo' }}
              {...props}
          />
      );
  }

  const handleCooldownsModalClose = () => {
    setCooldownsModalOpen(false);
    setCheckCooldownsModalOpen(false);
  }

  const giveCooldown = async () => {
    if (suspended || promoted) {
      if (cooldownTest === "radio" || cooldownTest === "bls" || cooldownTest === "smuls" || cooldownTest === "rezidentiat" || cooldownTest === "pilot" || cooldownTest === "moto") {
        if (Number(cooldownDays) >= 0) {
          try {
            let token = Cookies.get("accessToken");
            if (!token) {
              toast.error("Nu ai un token de acces valabil!");
              return;
            }

            try {
              await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
                  callsign: selectedMemberData?.callsign,
                  cooldownTest: cooldownTest,
                  cooldownDays: cooldownDays,
                  hrDiscordID: myDiscordID,
                  message: false
              }, { headers: { Authorization: `Bearer ${token}` } });

              handleCooldownsModalClose();
              toast.success("Cooldown-ul a fost acordat cu succes!");
            } catch (err) {
              if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                let refreshToken = Cookies.get("refreshToken");
                if (!refreshToken) {
                  toast.error("Nu ai un refresh token valabil!");
                  return;
                }

                const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh-token", {
                  refreshToken: refreshToken
                });

                if (refreshResponse.status === 200) {
                  const newAccessToken = refreshResponse.data.accessToken;
                  Cookies.set("accessToken", newAccessToken);

                  await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
                    callsign: selectedMemberData?.callsign,
                    cooldownTest: cooldownTest,
                    cooldownDays: cooldownDays,
                    hrDiscordID: myDiscordID,
                    message: false
                  }, { headers: { Authorization: `Bearer ${newAccessToken}` } });

                  handleCooldownsModalClose();
                  toast.success("Cooldown-ul a fost acordat cu succes!");
                } else {
                  toast.error("Refresh token-ul nu este valid!");
                }
              } else {
                toast.error("A aparut o eroare! Cooldown-ul nu a fost acordat.");
              }
            }
          } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Cooldown-ul nu a fost acordat.");
          }
        } else {
          toast.error("Zile invalide");
        }
      } else {
        toast.error("Test invalid");
      }
    } else {
        toast.error("Nu ai selectat nicio actiune!");
    }
  }


  const handleCheckCooldownsModalOpen = () => {
    setCheckCooldownsModalOpen(true);
    setCheckedCooldowns([]);
  }

  const checkCooldowns = async () => {  
    if (Number(checkCooldownsCallsign) > 0) {
      let checkMember = membersData.find((m) => m.callsign === Number(checkCooldownsCallsign));
      if (checkMember) {
        const response = await axios.get(`http://panelmedici.fplayt.ro:5000/api/check-cooldown?callsign=${checkMember.callsign}`);
        if (response.statusText === "OK") {
          setCheckedCooldowns(JSON.parse(response.data.cooldowns));
        } else {
          toast.error("A aparut o eroare! Cooldown-ul nu a fost verificat.")
        }
      } else {
        toast.error("Nu exista niciun medic cu acest callsign!");
        return;
      }
    } else {
      toast.error("Callsign invalid!");
      return;
    }
  }

  const getCooldownDisplay = () => {
    const currentDate = new Date();

    const formatDate = (dateString: string): Date => {
      const [day, month, year] = dateString.split(".");
      return new Date(`${year}-${month}-${day}`);
    };

    interface CooldownData {
      [key: string]: string;
    }

    const getDaysDifference = (dateString: string): number => {
      const targetDate = formatDate(dateString);
      const diffTime = targetDate.getTime() - currentDate.getTime();
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    };

    return Object.entries(checkedCooldowns)
        .filter(([_, value]) => value !== "-")
        .map(([key, value]) => {
            const daysLeft = getDaysDifference(value);
            return (
                <span key={key} className="text-black dark:text-white textRegulara text-[0.8vw]">
                    {key.charAt(0).toUpperCase() + key.slice(1)} - {value} ({daysLeft} zile)
                    <br />
                </span>
            );
        });
    };

  return (
    <div className="w-full h-full flex flex-col">
      <HeaderBar currentPage="Membrii Departament"/>
      <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
        <div className="w-full h-[7%] flex items-center justify-between">
          <span className="textSemiBold text-[1.1vw] text-[#000000] dark:text-[#ffffff]">Membrii Departament</span>
          <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
            <div onClick={handleCheckCooldownsModalOpen} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
              <span className="textBold text-white text-[.8vw]">CHECK COOLDOWN</span>
            </div>
            {isConducere && (
              <>
                <div onClick={openUpMemberModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">UP</span>
                </div>
                <div onClick={openDoubleUpMemberModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">DOUBLE UP</span>
                </div>
                <div onClick={openDownMemberModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">DOWN</span>
                </div>
                <div onClick={openChangeCallsignModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">SCHIMBA CALLSIGN</span>
                </div>
                <div onClick={handleOpenOutMember} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                  <span className="textBold text-white text-[.8vw]">DEMITERE</span>
                </div>
              </>
            )}
          </div>
          <div className="bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
            <input
              type="text"
              placeholder="Caută un medic"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pb-[1%] text-[#00000050] dark:text-[#ffffff50] dark:placeholder-[#ffffff50] placeholder-[#00000050] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
            />
            <FontAwesomeIcon className="text-[#00000050] dark:text-[#ffffff50] text-[0.8vw]" icon={faMagnifyingGlass} />
          </div>
        </div>
        <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
          {filteredMembers.map((memberData, index) => (
            <div key={index} className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]">
              {memberData.reintegrated ? (
                <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">RE: {memberData.user_id}</span>
              ) : (
                <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">{memberData.user_id}</span>
              )}
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">M-{String(memberData.callsign).padStart(3, '0')}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">{memberData.full_name}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">{memberData.grade}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <div className="w-[7%] h-full flex items-center justify-center">
                <div className="w-[90%] h-[60%] flex items-center justify-center bg-[#22df11] rounded-3xl">
                  <span className="textSemiBold text-white text-[0.8vw]">ACTIV</span>
                </div>
              </div>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <div onClick={() => handleOpen(memberData.discordID)} className="w-[13.5%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                <span className="textBold text-white text-[.7vw]">AFISEAZA FUNCTII/CERTIFICATE</span>
              </div>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[11%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">Data Intrare: {formatDate(memberData.entry_date)}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[11%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">Ultimul UP: {memberData.last_up === null ? "N/A" : formatDate(new Date(memberData.last_up))}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span
                className={`textSemiBold w-[0.8%] text-center text-[0.8vw] ${
                    memberData.fw === 0
                        ? 'text-green-500 dark:text-green-500'
                        : memberData.fw === 1
                        ? 'text-orange-500 dark:text-orange-500'
                        : 'text-red-500 dark:text-red-500'
                } dark:text-[#ffffff]`}
              >
                {memberData.fw}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">{memberData.discordID}</span>
            </div>
          ))}
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="flex flex-col">
            <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">Informatii - [M-{selectedMemberData?.callsign?.toString().padStart(3, '0') || 'N/A'}] {selectedMemberData?.full_name}</span>
            <div className="w-[100%] h-[70%] bg-[#f1f1f1] dark:bg-[#282828] rounded-[0.5vw] flex items-center justify-center gap-[0.5%]">
              <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                <span className="textSemiBold text-[1.2vw] mt-[1%] text-center text-[#000000] dark:text-white">Atribuții</span>
                <div className="w-full h-full flex flex-col text-base">
                  {membersData && membersData.length > 0 && selectedMemberData?.functions ? (
                    (() => {
                      const functions = typeof selectedMemberData.functions === 'string'
                        ? JSON.parse(selectedMemberData.functions) 
                        : selectedMemberData.functions; 

                      return Object.entries(functions).map(([key, value]) => (
                        <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                          <span className="textSemiBold text-[1vw] text-[#323232] dark:text-white">
                            {key.charAt(0).toUpperCase() + key.slice(1)} 
                          </span>
                          <div className="flex items-center gap-[2%] justify-end w-[40%]">
                            {isEditing && (
                              <div
                                onClick={() => handleToggleFunction(key, !value)}
                                className={`w-[1vw] h-[1vw] rounded-full box-border flex items-center justify-center pb-[5%] cursor-pointer ${
                                  value ? 'bg-red-500' : 'bg-green-500'
                                } text-white`}
                              >
                                {value ? '-' : '+'}
                              </div>
                            )}
                            <span className="textSemiBold gradient-text text-[1vw]">
                              {typeof value === 'string' ? value : value ? 'DA' : 'NU'} 
                            </span>
                          </div>
                        </div>
                      ));
                    })()
                  ) : (
                    <div className="textMedium text-[#323232] dark:text-white text-[1vw] w-full h-full flex items-center justify-center">
                      Nu ai nicio functie atribuita.
                    </div>
                  )}
                </div>
              </div>
              <div className="w-[1px] h-[90%] bg-[#929292]"></div>
              <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                <span className="textSemiBold text-[1.2vw] mt-[1%] text-center text-[#000000] dark:text-white">Certificate</span>
                <div className="w-full h-full flex flex-col items-center text-base">
                  {membersData && membersData.length > 0 && selectedMemberData?.certificates ? (
                    (() => {
                      const certificates = typeof selectedMemberData.certificates === 'string'
                        ? JSON.parse(selectedMemberData.certificates) 
                        : selectedMemberData.certificates; 

                      return Object.entries(certificates).map(([key, value]) => (
                        <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                          <span className="textSemiBold text-[1vw] text-[#323232] dark:text-white">
                            {key.charAt(0).toUpperCase() + key.slice(1)} 
                          </span>
                          <div className="flex items-center gap-[2%] justify-end w-[40%]">
                            {isEditing && (
                              <div
                                onClick={() => handleToggleCertificate(key, !value)}
                                className={`w-[1vw] h-[1vw] rounded-full box-border flex items-center justify-center pb-[5%] cursor-pointer ${
                                  value ? 'bg-red-500' : 'bg-green-500'
                                } text-white`}
                              >
                                {value ? '-' : '+'}
                              </div>
                            )}
                            <span className="textSemiBold gradient-text text-[1vw]">
                              {typeof value === 'string' ? value : value ? 'DA' : 'NU'} 
                            </span>
                          </div>
                        </div>
                      ));
                    })()
                  ) : (
                    <div className="textMedium text-[#323232] dark:text-white text-[1vw] w-full h-full flex items-center justify-center">
                      Nu ai niciun certificat.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">Actiuni HR / CONDUCERE</span>
            <div className="w-full h-[22%] flex flex-wrap flex-row gap-[1%] items-center justify-center">
              {(isConducere || getDiscordMemberInfo(myDiscordID, "grade") === "Responsabil-Panel") ? (
                <>
                  <div
                    onClick={toggleEditMode}
                    className={`h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r ${
                      isEditing ? "from-[#2dd80f] to-[#22d60a]" : "from-[#D8630F] to-[#F59318]"
                    }`}
                  >
                    <span className="textBold text-white text-[.8vw]">
                      {isEditing ? "SALVEAZA MODIFICARILE" : "GESTIONEAZA ATRIBUTII/CERTIFICATE"}
                    </span>
                  </div>
                  <div onClick={handleOpenFWModal} className="h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                    <span className="textBold text-white text-[.8vw]">FW</span>
                  </div>
                  <div onClick={handleOpenFineModal} className="h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                    <span className="textBold text-white text-[.8vw]">AMENDA</span>
                  </div>
                  <div
                    onClick={handleOpenCooldownsModal}
                    className={`h-[50%] px-[4%] ${
                      isEditing ? "mt-[0]" : "mt-[1%]"
                    } flex items-center justify-center rounded-[.2vw] bg-gradient-to-r from-[#D8630F] to-[#F59318] cursor-pointer`}
                  >
                    <span className="textBold text-white text-[.8vw]">COOLDOWN-URI</span>
                  </div>
                  <div onClick={() => checkPunishments(Number(selectedMemberData?.callsign))} className="h-[50%] px-[4%] mt-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                    <span className="textBold text-white text-[.8vw]">VERIFICA SANCTIUNI</span>
                  </div>
                </>
              ) : isHR ? (
                <>
                  <div
                    onClick={toggleEditMode}
                    className={`h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r ${
                      isEditing ? "from-[#2dd80f] to-[#22d60a]" : "from-[#D8630F] to-[#F59318]"
                    }`}
                  >
                    <span className="textBold text-white text-[.8vw]">
                      {isEditing ? "SALVEAZA MODIFICARILE" : "GESTIONEAZA ATRIBUTII/CERTIFICATE"}
                    </span>
                  </div>
                  <div
                    onClick={handleOpenCooldownsModal}
                    className='h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] bg-gradient-to-r from-[#D8630F] to-[#F59318] cursor-pointer'
                  >
                    <span className="textBold text-white text-[.8vw]">COOLDOWN-URI</span>
                  </div>
                </>
              ) : (
                <div></div>
              )}
            </div>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={cooldownsModalOpen}
        onClose={handleCooldownsModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={cooldownsModalOpen}>
        <Box sx={cooldownsStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">COOLDOWN TEST</span>
          <div className="w-[60%] h-[25%] flex flex-row items-center justify-center">
            <div className="w-[50%] h-[10%] mt-[1%] flex flex-row items-center">
                <BpCheckbox checked={promoted} onChange={(event) => setPromoted(event.target.checked)} />
                <span className="textSemiBold text-black dark:text-white text-[1vw] h-full flex items-center">Nepromovat</span>
            </div>
            <div className="w-[50%] h-[10%] mt-[1%] flex flex-row items-center">
                <BpCheckbox checked={suspended} onChange={(event) => setSuspended(event.target.checked)} />
                <span className="textSemiBold text-black dark:text-white text-[1vw] h-full flex items-center">Confiscat</span>
            </div>
          </div>
          <input
            onChange={e => setCooldownTest(e.target.value)}
            placeholder="Introdu test (ex: radio)"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setCooldownDays(e.target.value)}
            placeholder="Introdu zile cooldown"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={giveCooldown} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERA COOLDOWN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={checkCooldownsModalOpen}
        onClose={handleCooldownsModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={checkCooldownsModalOpen}>
        <Box sx={cooldownsStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">VERIFICA COOLDOWN-URI</span>
          <input
            onChange={e => setCheckCooldownsCallsign(e.target.value)}
            placeholder="Introdu callsign"
            type="text"
            className="w-[60%] h-[20%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div className="w-[60%] h-[55%] flex flex-col items-center justify-center">
            <span className="text-black dark:text-white textSemiBold text-[1.1vw]">Lista cooldown-uri active:</span>
            <div className="w-[100%] h-[85%] flex flex-col items-center justify-center text-base/5">
              {getCooldownDisplay()}
            </div>
          </div>
          <div onClick={checkCooldowns} className="cursor-pointer mt-[2%] w-[70%] h-[25%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">VERIFICA COOLDOWN-URI</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={upModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={upModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">UP MEMBRU</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={upMember} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">OFERA UP</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={doubleUpModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={doubleUpModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">DOUBLE-UP MEMBRU</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={doubleUpMember} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">OFERA DOUBLE UP</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={downModalOpen}
        onClose={handleDownModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={downModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">DOWN MEMBRU</span>
          <input
            onChange={e => setDOWNCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={downMember} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERA DOWN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={changeCallsignOpen}
        onClose={handleChangeCallsignModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={changeCallsignOpen}>
        <Box sx={changeCallsignStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">SCHIMBA CALLSIGN</span>
          <input
            onChange={e => setOldCallsign(e.target.value)}
            placeholder="Introdu Callsign vechi"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setNewCallsign(e.target.value)}
            placeholder="Introdu Callsign nou"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={changeCallsign} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">SCHIMBA CALLSIGN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={fwModalOpen}
        onClose={handleFWClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={fwModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">FW</span>
          <input
            onChange={e => setFWInput(e.target.value)}
            placeholder="Introdu motiv FW"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={giveFW} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERA FW</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={fineModalOpen}
        onClose={handleFineClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={fineModalOpen}>
        <Box sx={changeCallsignStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">AMENDA</span>
          <input
            onChange={e => setFineReason(e.target.value)}
            placeholder="Introdu motiv AMENDA"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setFineAmount(e.target.value)}
            placeholder="Introdu suma AMENDA"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={giveFine} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERA AMENDA</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={OpenDemiteModal}
        onClose={handleDemitereClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={OpenDemiteModal}>
        <Box sx={demisieStyle} className="flex flex-col items-center">
          <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">DEMITE MEMBRU</span>
          <input
            onChange={e => setDemiteCallsign(e.target.value)}
            placeholder="Introdu callsign (ex: 501)"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setDemiteDays(e.target.value)}
            placeholder="Cate zile trebuie sa isi ia ban?"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={outMember} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">DEMITE MEMBRU</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <ToastContainer />
    </div>
  );
}

export default MembersPage;